import type { Category, EventDesignFragment } from '@graphql/generated';

/**
 * Builds a map of font category → font family from an event design's font configuration.
 * Returns undefined if no fonts are provided.
 */
export function buildFontCategoryMap(fonts: EventDesignFragment['fonts']): Partial<Record<Category, string>> | undefined {
  if (!fonts) return undefined;
  return fonts.reduce((acc, font) => ({ ...acc, [font.category]: font.font?.fontFamily }), {} as Partial<Record<Category, string>>);
}
